import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';

@Component({
    selector: 'app-kunde-form',
    templateUrl: './kunde-form.component.html',
    styleUrls: ['./kunde-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KundeFormComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() serviceaftale: ServiceaftaleDto;
  @Input() kunde: KundeDto;
  @Output() reload: EventEmitter<void> = new EventEmitter();

  get okKundeAftaleNr() {
    return this.form.get('okKundeAftaleNr');
  }

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  onSearchClick() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        okKundeAftaleNr: this.okKundeAftaleNr.value,
        t: new Date().getTime(),
      },
      queryParamsHandling: 'merge',
    });
  }
}
